module.exports = __webpack_public_path__ + "static/media/WEBnegro_70.35837357.png";